const visibleUrlPattern = /\b(?:https?:\/\/|www\.)[^\s<>]+/gi;

const splitTrailingPunctuation = (value) => {
    let url = value;
    let trailing = "";

    while (/[.,;:!?]$/.test(url)) {
        trailing = url.slice(-1) + trailing;
        url = url.slice(0, -1);
    }

    const unmatchedClosingParentheses =
        (url.match(/\)/g) || []).length - (url.match(/\(/g) || []).length;
    if (unmatchedClosingParentheses > 0 && url.endsWith(")")) {
        trailing = ")" + trailing;
        url = url.slice(0, -1);
    }

    return { url, trailing };
};

/**
 * Converts visible URLs in already-sanitized HTML into safe links and ensures
 * every link opens outside the current application tab.
 */
const linkifySanitizedHtml = (html) => {
    if (!html) return "";

    const container = document.createElement("div");
    container.innerHTML = html;

    const walker = document.createTreeWalker(container, 4);
    const textNodes = [];
    let currentNode;

    while ((currentNode = walker.nextNode())) {
        if (currentNode.parentElement?.closest("a")) continue;
        textNodes.push(currentNode);
    }

    textNodes.forEach((textNode) => {
        const text = textNode.nodeValue;
        const matches = [...text.matchAll(visibleUrlPattern)];
        if (matches.length === 0) return;

        const fragment = document.createDocumentFragment();
        let cursor = 0;

        matches.forEach((match) => {
            const { url, trailing } = splitTrailingPunctuation(match[0]);
            fragment.append(document.createTextNode(text.slice(cursor, match.index)));

            const link = document.createElement("a");
            link.href = url.startsWith("www.") ? `https://${url}` : url;
            link.target = "_blank";
            link.rel = "noopener noreferrer";
            link.textContent = url;
            fragment.append(link);

            if (trailing) fragment.append(document.createTextNode(trailing));
            cursor = match.index + match[0].length;
        });

        fragment.append(document.createTextNode(text.slice(cursor)));
        textNode.replaceWith(fragment);
    });

    container.querySelectorAll("a").forEach((link) => {
        link.target = "_blank";
        link.rel = "noopener noreferrer";
    });

    return container.innerHTML;
};

export { linkifySanitizedHtml };
